import { render } from "./MatchdayTakeover.vue?vue&type=template&id=0229db08&scoped=true"
import script from "./MatchdayTakeover.vue?vue&type=script&lang=js"
export * from "./MatchdayTakeover.vue?vue&type=script&lang=js"

import "./MatchdayTakeover.vue?vue&type=style&index=0&id=0229db08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0229db08"]])

export default __exports__